import { render, staticRenderFns } from "./UsingTheConfigurator.vue?vue&type=template&id=8926974a&scoped=true"
import script from "./UsingTheConfigurator.vue?vue&type=script&lang=js"
export * from "./UsingTheConfigurator.vue?vue&type=script&lang=js"
import style0 from "./UsingTheConfigurator.vue?vue&type=style&index=0&id=8926974a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8926974a",
  null
  
)

export default component.exports